// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3qRc-","dragIcon":"SortableItem_dragIcon__b8Ftm","disabled":"SortableItem_disabled__C_fUx"};